<template>
    <div>
        <loading :dspin="displayLoading"></loading>
        <div v-if="!displayLoading">
            <form class="flow-form-cum-panel flow-card blue-top w3-col">
                <div class="w3-container flow-padding-top">
                    <p class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("name") }}</label>
                        <input class="w3-input" v-bind:class="nameError ? 'error' : ''" type="text" v-bind:placeholder="$t('enter.name')" v-model="name">
                        <span class="w3-text-red"> {{ nameError }} </span>
                    </p>

                    <p class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("dobRequired") }}</label>
                        <input v-bind:class="this.dobError ? 'error' : ''" class="w3-input" type="text" v-model="dob" placeholder="dd-mm-yyyy" :title="$t('INVALID_DOB_FORMAT')">
                        <span class="w3-text-red"> {{ dobError }} </span>
                    </p>
                </div>

                <div class="w3-container zero-top">
                    <p v-bind:class="physicians.length < 1 ? 'w3-disabled' : ''"
                       class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("physicians") }}</label>
                        <flow-select :items="physicians" :valueKey="'name'" :valueKeyIndex="'id'" :preSelectedItem="physician"
                                     :callback="selectPhysician"></flow-select>
                    </p>

                    <span v-show="!isFastTrackForm || groups.length > 1">
                        <p v-bind:class="groups.length < 1 ? 'w3-disabled' : ''"
                           class="w3-col w-45pc flow-form-inline-input">
                            <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("appointmentTypes") }}</label>
                            <flow-select :items="groups" :valueKey="'displayName'" :valueKeyIndex="'id'" :preSelectedItem="group" :callback="selectGroup"></flow-select>
                        </p>
                    </span>
                </div>


                <div class="w3-container zero-top">
                    <p class="w3-col w-30pc flow-form-inline-input w3-left">
                        <label class="w3-left flow-blue-color flow-padding-bottom w-100pc">{{ $t("time") }}</label>
                        <input class="w3-input w-90pc w3-show-inline-block time-picker-trigger" type="text"
                               v-bind:placeholder="$t('select.time')"
                               v-bind:class="timeError ? 'error' : ''"
                               @click="openTimePicker = !openTimePicker"
                               v-bind:value="appointmentTime.val"/>
                        <i class="far fa-clock w3-large flow-blue-color flow-padding-left cursor-pointer w3-ripple time-picker-trigger"
                           @click="openTimePicker = !openTimePicker" :title="$t('openTimePicker')"></i>
                        <span class="w3-text-red"> {{ timeError }} </span>
                    </p>

                    <div v-if="!isFastTrackForm">
                        <p class="w3-col w-30pc flow-form-inline-input zero-bottom flow-margin-top-3-pct">
                            <button class="fa fa-star appointment-priority cursor-pointer w3-large w3-border-0 w3-transparent"
                                    @click.prevent="hasPriority = !hasPriority"
                                    v-bind:class="hasPriority ? 'active' : 'inactive'">
                            </button>
                            <label class="flow-blue-color flow-padding-bottom">{{ $t("givePriority") }}</label>
                        </p>
                    </div>

                    <div>
                        <p class="w3-col w-60pc flow-form-inline-input time-picker-container">
                            <time-picker v-show="openTimePicker"
                                         class="flow-card w3-animate-opacity"
                                         :onChange="onChange"
                                         :preSelected="appointmentTime"
                                         :onClose="()=>{openTimePicker = false;}">
                            </time-picker>
                        </p>
                    </div>


                </div>

                <div class="w3-container zero-top">
                    <p v-if="!isFastTrackForm" class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("internalId") }}</label>
                        <input class="w3-input" type="text" v-bind:placeholder="$t('enter.internalId')"
                               v-bind:class="internalIdError ? 'error' : ''"
                               v-model="internalId">
                        <span class="w3-text-red"> {{ internalIdError }} </span>
                    </p>
                    <p class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("tag") }}</label>
                        <input v-bind:class="this.tagError ? 'error' : ''" class="w3-input" type="text" v-bind:placeholder="$t('enter.tag')" v-model="ticket">
                        <span class="w3-text-red"> {{ tagError }} </span>
                    </p>
                </div>

                <div v-if="!isFastTrackForm" class="w3-container zero-top">
                    <p class="w3-col flow-form-inline-input flow-margin-top" style="width: 92%">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("comments") }}</label>
                        <textarea class="w3-input" v-bind:placeholder="$t('enter.comments')"
                                  v-model="comment"></textarea>
                    </p>
                </div>

                <div v-if="!isFastTrackForm" class="w3-container zero-top">
                    <p v-bind:class="locationList.length < 1 ? 'w3-disabled' : ''"
                       class="w3-col w-45pc flow-form-inline-input">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("location") }}</label>
                        <flow-select :items="locationList" :valueKey="'displayName'" :valueKeyIndex="'id'" :preSelectedItem="location"
                                     :callback="selectLocation"></flow-select>
                    </p>
                    <p class="w3-col w-45pc flow-form-inline-input" v-if="isDH">
                        <label class="w3-left flow-blue-color flow-padding-bottom">{{ $t("assignedRoom") }}</label>
                        <input class="w3-input" type="text" v-bind:placeholder="$t('enter.room')" v-model="room">
                    </p>
                </div>

                <div class="w3-container zero-top">
                    <p class="flow-form-inline-input">
                        <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left w3-margin-right w3-margin-top w3-large"
                                @click.prevent="save">
                            <i class="fa fa-save flow-green-active-color">
                                <span><b class="flow-margin-left">{{$t('save')}}</b></span>
                            </i>
                        </button>

                        <button class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-left w3-margin-top w3-large"
                                @click.prevent="onClose">
                            <i class="fa fa-arrow-left w3-text-red">
                                <span><b class="flow-margin-left">{{$t('back')}}</b></span>
                            </i>
                        </button>
                    </p>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import FlowSelect from "../common/FlowSelect";
    import TimePicker from "../common/TimePicker";
    import Loading from "../common/Loading";
    import {EventBus} from "../../main";

    const frc = Vue.prototype.$frc;

    export default {
        name: "NewPatientCard",
        components: {Loading, TimePicker, FlowSelect},
        props: ['onClose', 'isFastTrackForm'],
        data() {
            return {
                name: '',
                internalId: '',
                appointmentTime: '',
                group: undefined,
                location: undefined,
                physician: undefined,
                ticket: '',
                room: '',
                comment: '',
                loadingLocations: false,
                locations: [],
                groups: [],
                physicians: [],
                openTimePicker: false,
                displayLoading: false,
                nameError: '',
                timeError: '',
                internalIdError: '',
                tagError: '',
                hasPriority: false,
                wards: [],
                dob: '',
                dobError: ''
            }
        },
        beforeCreate() {
            const wardId = Vue.prototype.$currentWard.id;
            const app = this;

            frc.getConsultationGroupsInWard(wardId).then(function (res) {
                app.groups = res.data;
                Vue.sortByKey(app.groups, 'displayName');
            });

            frc.getPhysiciansInWard(wardId).then(function (res) {
                app.physicians = res.data;
                Vue.sortByKey(app.physicians, 'name');
            });

            frc.getWards().then(function (res) {
                app.wards = res.data;
                Vue.sortByKey(app.wards, 'displayName');
            });
        },
        mounted() {
            if (this.isFastTrackForm) {
                this.location = Vue.prototype.$currentWard;
            }
        },
        computed: {
            locationList() {
                var result = this.locations.concat(this.wards);
                Vue.sortByKey(result, 'displayName');
                result.unshift({id:null, displayName: this.$t("none")});

                return result;
            },
            isDH() {
                return Vue.prototype.$showStatusOverviewMenu;
            }
        },
        methods: {
            onChange(time) {
                this.appointmentTime = time;
            },
            selectPhysician(physician) {
                if (physician) {
                    this.physician = physician;
                }
            },
            selectGroup(group) {
                if (!group) {
                    return;
                }
                this.group = group;
                this.fetchWAsInGroup();
            },
            selectLocation(location) {
                if (location) {
                    this.location = location;
                }
            },
            save() {
                this.nameError = '';
                this.timeError = '';
                this.tagError = '';
                this.internalIdError = '';
                this.dobError = '';
                var dateFormatCheck = /^(0[1-9]|[12][0-9]|3[01])[-](0[1-9]|1[012])[-](18|19|20)\d\d$/.test(this.dob);
                var today = new Date();
                var rawFormatDate = this.dob === '' ? '' : new Date(Vue.getYMDFromDMY(this.dob));
                var ageInYears = (today - rawFormatDate) / 31556952000;

                if (!(this.name && this.name.trim())) {
                    this.nameError = this.$t("INVALID_NAME");
                    return;
                }

                if (!(this.appointmentTime && this.appointmentTime.val && this.appointmentTime.val.trim())) {
                    this.timeError = this.$t("INVALID_TIME");
                    return;
                }

                if (this.dob !== '' && !dateFormatCheck) {
                    this.dobError = this.$t("INVALID_DOB_FORMAT");
                    return;
                }

                if (this.dob !== '' && (ageInYears > 110 || ageInYears < 0)) {
                    this.dobError = this.$t("INVALID_DOB");
                    return;
                }

                if (this.dob !== '' && this.group.id === 'dh.ort.minors' && ageInYears > 18) {
                    this.dobError = this.$t("INVALID_DOB_MINOR");
                    return;
                }

                if (this.dob !== '' && this.group.id === 'dh.ort.adults' && ageInYears < 14) {
                    this.dobError = this.$t("INVALID_DOB_ADULT");
                    return;
                }

                const app = this;
                app.displayLoading = true;
                var dob = app.group.id==='dh.ort.minors' && app.dob==='' ? Vue.setDateObjectToYMD(today) : Vue.setDateObjectToYMD(rawFormatDate);

                frc.createPatientWithAppointment(Vue.prototype.$currentWard.id, {
                    name: app.name,
                    internalId: app.internalId,
                    ticket: app.ticket,
                    comment: app.comment,
                    appointmentTime: app.appointmentTime.val,
                    physicianId: app.physician.id,
                    groupId: app.group.id,
                    positionId: app.location.id,
                    hasPriority: app.hasPriority,
                    assignedRoom: app.room ? app.room : '',
                    dob: dob
                }).then(function (res) {
                    if (res.data && res.data.value) {
                        Vue.notifySuccess({title: app.$t("patientSuccessfullyCreated")});
                        EventBus.$emit("newPatientCreated", res.data.value);
                    } else {
                        console.log("Something went wrong!");
                    }
                    app.displayLoading = false;
                }).catch(function (ex) {
                    app.displayLoading = false;
                    if (!ex.restCodes) {
                        return;
                    }

                    if (ex.restCodes.includes("INVALID_NAME")) {
                        app.nameError = app.$t("INVALID_NAME");
                    }

                    if (ex.restCodes.includes("INVALID_TIME")) {
                        app.timeError = app.$t("INVALID_TIME");
                    }

                    if (ex.restCodes.includes("BADGE_EXISTS")) {
                        app.tagError = app.$t("BADGE_EXISTS");
                    }

                    if (ex.restCodes.includes("INVALID_BADGE")) {
                        app.tagError = app.$t("INVALID_BADGE");
                    }

                    if (ex.restCodes.includes("INTERNAL_ID_EXISTS")) {
                        app.internalIdError = app.$t("INTERNAL_ID_EXISTS");
                    }
                });
            },
            fetchWAsInGroup() {
                const wardId = Vue.prototype.$currentWard.id;
                const app = this;
                app.locations = [];
                app.loadingLocations = true;
                frc.getWaitingAreasInConsultationGroup(wardId, this.group.id)
                    .then(function (res) {
                        app.locations = res.data;
                        app.loadingLocations = false;
                    });
            }
        }
    }
</script>

<style scoped>

</style>